import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d34a782"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-spinner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-main" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin fa-6x" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}